import type {MultiSelectProps} from '@mantine/core';
import {Input, MultiSelect} from '@mantine/core';
import type {FC} from 'react';
import type {IListItem} from 'src/types/Form';

/**
 * Searchable, clearable multi-select rendered inside a labeled
 * `Input.Wrapper`, for choosing multiple items from a fixed list.
 * @registry Labeled, searchable multi-select wrapper.
 *
 * Ported from `library/elements/CheckboxList`. Prop surface kept identical.
 */
export interface CheckboxListProps {
  values: IListItem[];
  selected: string[];
  label: string;
  disabled?: boolean;
  error?: boolean;
  description?: string;
  required?: boolean;

  onChange: (values: string[]) => void;

  multiSelectProps?: MultiSelectProps;
}

export const CheckboxList: FC<CheckboxListProps> = ({
  values,
  selected,
  label,
  onChange,
  disabled,
  required,
  error,
  description,
  multiSelectProps,
}) => {
  const handleChange = (values: string[]) => {
    onChange(values);
  };

  return (
    <Input.Wrapper
      label={label}
      error={error}
      withAsterisk={required}
      description={description}
      descriptionProps={{mb: 'xs'}}
      mb="md">
      <MultiSelect
        {...multiSelectProps}
        disabled={disabled}
        searchable
        clearable
        data={values}
        value={selected}
        onChange={handleChange}
        nothingFoundMessage="No options available"
      />
    </Input.Wrapper>
  );
};
